import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
export { isEligibleForReleaseNotesDiscovery } from '../src/rovo/ReleaseNotesDialog.tsx';
export const LazyReleaseNotesPublishDiscoveryDialog: LoadableType<{
	onClose: () => void;
	onCloseComplete: () => void;
	publishedPageTitle: string;
	spaceName: string;
	spaceKey?: string;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReleaseNotesDialog" */ '../src/rovo/ReleaseNotesDialog.tsx'
			)
		).ReleaseNotesDialog,
});
